/**
 * @generated SignedSource<<36ef6c4f24ebeaf1e4dcd770c0d3aa94>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AssigneePicker$data = {
  readonly jqlBuilder: {
    readonly fieldValues: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: string;
          readonly displayName: string;
          readonly jqlTerm: string;
          readonly user?: {
            readonly picture: AGG$URL;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    };
  } | null | undefined;
  readonly " $fragmentType": "AssigneePicker";
};
export type AssigneePicker$key = {
  readonly " $data"?: AssigneePicker$data;
  readonly " $fragmentSpreads": FragmentRefs<"AssigneePicker">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "assignees"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "scope"
    }
  ],
  "kind": "Fragment",
  "name": "AssigneePicker",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "concreteType": "JiraJqlBuilder",
      "kind": "LinkedField",
      "name": "jqlBuilder",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "args": [
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "assignees"
              },
              {
                "kind": "Literal",
                "name": "jqlTerm",
                "value": "assignee"
              },
              {
                "kind": "Variable",
                "name": "scope",
                "variableName": "scope"
              }
            ],
            "concreteType": "JiraJqlFieldValueConnection",
            "kind": "LinkedField",
            "name": "fieldValues",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraJqlFieldValueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "jqlTerm"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "displayName"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "picture"
                              }
                            ]
                          }
                        ],
                        "type": "JiraJqlUserFieldValue"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          "action": "THROW",
          "path": "jqlBuilder.fieldValues"
        }
      ]
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "2d38df910018bd18525a73536811a1f9";

export default node;
